import type { ReactNode } from "react";

import { ErrorBoundary } from "@/components/ui/error-boundary";
import { SkipLink } from "@/components/ui/skip-link";
import { useSiteShared } from "@/config/use-site-content";
import { useT } from "@/i18n/locale-context";
import { createThemeStyle } from "@/lib/site-config";

interface AdminLayoutShellProps {
  children: ReactNode;
}

export function AdminLayoutShell({
  children,
}: AdminLayoutShellProps): JSX.Element {
  const shared = useSiteShared();
  const t = useT();

  return (
    <div style={createThemeStyle(shared.theme)}>
      <SkipLink>{t("common.skipToContent")}</SkipLink>
      <main id="main" tabIndex={-1}>
        <ErrorBoundary
          copy={{
            eyebrow: t("errors.boundaryEyebrow"),
            hint: t("errors.boundaryHint"),
            retryLabel: t("actions.tryAgain"),
            title: t("errors.boundaryTitle"),
          }}
        >
          {children}
        </ErrorBoundary>
      </main>
    </div>
  );
}
